import { tApi } from 'tplus-api';
import tools from '../util/tools';
/**
 * 记操作日志API
 * POS端每个操作都需要在T+的表EAP_OPERATION
 */
export default class OperationLogApi {
    //获取存货明细信息
    static async log(params) {
        const {operationName,description} = params;
        return await tApi({
            bringType: '1',
            strModuleCode: 'RE',
            strFunctionCode: 'RE3002',
            strOperationName: operationName,
            status: 1,
            strDocNo: '1234567',
            strDescription: description,
            dtFunctionDate: tools.getCurDateTime(),
        }, 'chanjet.SM.CommonInterface.IOperationLogService.AddLog', false, false);
    }

    //添加POS操作日志
    static async addPosLog(title,docno,description)
    {
        if(!docno)
        {
            docno=" ";
        }
        return await tApi({
            title: title,
            code: docno,
            description: description,
            isShow:false
        }, 'chanjet.RE.NewPos.AddPosLog', false, false, {timeout_skip:true});
    }
    //添加POS操作日志
    static async addPosLogWithShow(title,docno,description,isShow)
    {
        if(!docno)
        {
            docno=" ";
        }
        return await tApi({
            title: title,
            code: docno,
            description: description,
            isShow:isShow
        }, 'chanjet.RE.NewPos.AddPosLog', false, false, {timeout_skip:true});
    }
}

